import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { LayoutContext } from './LayoutContext';

import { useIsMobileLayout } from '../../hooks';

import rightGraySvg from '../../assets/imgs/graphism-right-grayscale.svg';
import rightSvg from '../../assets/imgs/graphism-right.svg';
import leftGraySvg from '../../assets/imgs/graphism-left-grayscale.svg';
import leftSvg from '../../assets/imgs/graphism-left.svg';

import Header from './Headers/DefaultHeader';
import Box from '../../components/Styled/Box';

const SideImage = styled(Box)`
  position: fixed;
  height: 100vh;
  width: 50%;
  top: 64px;
  right: 0;
  z-index: 0;
  flex: 1;
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const SvgImage = styled.img`
  position: fixed;
  z-index: -1;

  ${({ left, grayScale }) => left && `
    left: ${grayScale ? '0' : '-150px'};
    top: 150px;
    opacity: ${grayScale ? '1' : '0.75'};
  `}

  ${({ right, grayScale }) => right && `
    right: 0;
    bottom: ${grayScale ? '150px' : '0'};
    opacity: ${grayScale ? '1' : '0.75'};
  `}
`;

const LayoutWithHeader = ({ children }) => {
  const {
    // graphism,
    color,
    image,
    hubSpotCss,
  } = React.useContext(LayoutContext);

  const graphism = false;
  const hubSpotRef = React.useRef(null);
  const isMobile = useIsMobileLayout();
  const [prevStyle, setPrevStyle] = React.useState('');
  const backgroundColor = isMobile ? 'coldgrey100' : 'coldgrey200';
  const paddingTop = isMobile ? 0 : 5;

  if (isMobile && !hubSpotRef.current) {
    const hubSpot = document?.getElementById('hubspot-messages-iframe-container');
    if (hubSpot) {
      hubSpotRef.current = hubSpot;
    }
  }

  React.useEffect(() => {
    if (hubSpotRef.current) {
      const styles = hubSpotRef.current?.getAttribute('style');
      const includesStyle = styles?.includes(hubSpotCss);

      if (hubSpotCss && !includesStyle) {
        setPrevStyle(styles);
        hubSpotRef.current.setAttribute('style', styles + hubSpotCss);
      }
      if (!hubSpotCss && prevStyle) {
        hubSpotRef.current.setAttribute('style', prevStyle);
        setPrevStyle('');
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubSpotCss]);

  return (
    <Box>
      <Header />

      <Box.Main
        zIndex={100}
        pt={paddingTop}
        pb={isMobile ? 2 : 0}
        backgroundColor={backgroundColor}
        minHeight='100vh'
        display='flex'
        flexDirection='column'
        {...(!isMobile && image) && {
          width: '50%',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {children}

        {(!isMobile && graphism) && (
          <>
            <SvgImage
              alt='teal-graphism'
              src={color ? leftSvg : leftGraySvg}
              left
              grayScale={!color}
            />
            {!color && (
              <SvgImage
                alt='orange-graphism'
                src={rightGraySvg}
                right
                grayScale
              />
            )}
          </>
        )}

        {(!isMobile && image) && (
          <SideImage image={image}>
            {(graphism && color) && (
              <SvgImage
                alt='orange-graphism'
                src={rightSvg}
                right
              />
            )}
          </SideImage>
        )}
      </Box.Main>
    </Box>
  );
};

LayoutWithHeader.propTypes = {
  children: PropTypes.any,
};

LayoutWithHeader.defaultProps = {
  children: null,
};

export default LayoutWithHeader;
